import { Icon } from '@chakra-ui/react'
import React from 'react'

/**
 * メニュー ナビゲーションアイコン：広報かみやま
 */
const NavPractice: React.FC = (props) => (
  <Icon viewBox="0 0 80.76 59.34" {...props}>
    <rect x="-.16" y="4.38" width="81.08" height="1.46" transform="translate(-.32 4.41) rotate(-6.22)" fill="currentColor"/>
    <rect x="39.65" y="13.7" width="1.46" height="81.08" transform="translate(-17.9 88.52) rotate(-83.8)" fill="currentColor"/>
    <g>
      <path d="M9.93,42.89v-26.1c0-.47-.11-.82-.32-1.06-.21-.24-.59-.44-1.13-.59v-.72h17.21c3.77,0,6.66.43,8.68,1.29,2.89,1.25,5.03,3.31,6.42,6.19,1.1,2.26,1.65,4.9,1.65,7.93,0,5.32-1.64,9.37-4.91,12.16-1.37,1.17-2.98,2.02-4.82,2.52-1.84.5-4.18.76-7.03.76H8.48v-.72c.54-.15.92-.35,1.13-.59.21-.24.32-.59.32-1.06ZM16.66,40.18h8.46c2.7,0,4.73-.37,6.08-1.11,2.91-1.58,4.37-4.66,4.37-9.24,0-3.31-.78-5.85-2.35-7.61-.87-.98-1.93-1.68-3.17-2.09-1.24-.41-2.88-.62-4.93-.62h-8.46v20.67Z" fill="currentColor"/>
      <path d="M64.06,29.3l9.31,11.98c1.02,1.33,1.76,2.17,2.2,2.53.44.36,1.06.6,1.84.72v.72h-12.23v-.72c.9-.18,1.36-.57,1.36-1.17,0-.32-.27-.83-.81-1.54l-5.76-7.45-5.81,7.2c-.62.8-.93,1.36-.93,1.69,0,.75.5,1.17,1.51,1.27v.72h-11.85v-.72c.69-.07,1.23-.27,1.62-.59s1.16-1.2,2.32-2.67l9.43-11.72-8.68-11.23c-1.11-1.46-1.86-2.34-2.23-2.63-.37-.29-.96-.48-1.77-.55l-.02-.72h12.37v.72c-.9.24-1.36.7-1.36,1.38,0,.36.32.96.97,1.81l4.79,6.16,4.96-6.16c.72-.92,1.08-1.57,1.08-1.94,0-.66-.52-1.08-1.56-1.24v-.72h12.04v.72c-.72.08-1.24.24-1.55.49-.31.25-1.1,1.15-2.38,2.7l-8.86,10.97Z" fill="currentColor" />
    </g>
  </Icon>
)

export default NavPractice
